// extracted by mini-css-extract-plugin
export default {"reveal":"step-about-you_reveal__djrZ7","helperFloating":"step-about-you_helperFloating__ruYKC"};